export default __webpack_public_path__ + "static/media/scene.babd9afe.svg";